import Reveal from "@/components/Reveal";
import ProductGrid from "@/components/ProductGrid";

export default function Suits({ items, query }) {
  const q = (query || "").trim().toLowerCase();
  const filtered = q
    ? (items || []).filter((p) =>
        `${p.name} ${p.description || ""}`.toLowerCase().includes(q)
      )
    : items || [];
  const emptyHint = q
    ? `Keine Treffer für „${query.trim()}" — schreib uns per WhatsApp, was du suchst!`
    : "Neue Suiten kommen bald — frag gerne per WhatsApp an.";
  return (
    <section
      id="suits"
      className="relative scroll-mt-24 overflow-hidden py-24 md:py-32"
      data-testid="suits-section"
    >
      <div
        className="pointer-events-none absolute left-[-15%] top-1/4 h-[36rem] w-[36rem] rounded-full opacity-15 blur-[120px]"
        style={{ background: "radial-gradient(circle, #521023 0%, transparent 65%)" }}
      />
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal className="mb-12 flex flex-col gap-6 md:mb-16 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-4 text-xs font-light uppercase tracking-[0.35em] text-gold">
              02 — Suits
            </p>
            <h2 className="font-serif text-5xl font-light tracking-[-0.02em] text-cream md:text-7xl">
              Phulkari <em className="text-goldgrad">&amp; Suits</em>
            </h2>
          </div>
          <p className="max-w-xs text-sm font-light leading-relaxed text-rosy">
            Salwar, Kameez, Dupatta — handbestickte Phulkari-Kunst und farbenfrohe
            Suiten für jeden Anlass.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <ProductGrid
            items={filtered}
            testidPrefix="suits"
            emptyHint={emptyHint}
          />
        </Reveal>
      </div>
    </section>
  );
}
